import "@babel/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
  createEventDispatcher,
  EntityFrameworkConfig
} from "clavis-nxt-components-custdevtm";
import * as serviceWorker from "./serviceWorker";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./index.scss";
import "@webcomponents/webcomponentsjs/webcomponents-hi-sd-ce";
import { indexLoader } from "./modules/indexLoader/indexLoader";

const target = document.querySelector("#root");

window.React = React;
window.ReactDOM = ReactDOM;
window.ReactRedux = { connect };

const eventDispatcher = createEventDispatcher();

EntityFrameworkConfig.serverName = "";
EntityFrameworkConfig.contextPath = "";

indexLoader(eventDispatcher, target);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
